<template>
	<div id="slideView">
		<div v-if="1 == 2">
			Tick: {{ count }} Pause: {{ pause }} <br /><Button label="noll" @click="this.count = 0" />
			<Button label="Start" @click="onStartPressed" />
			<Button label="stop" @click="stop" />
			<Button label="<" @click="previous()" />
			<Button label=">" @click="next()" />
			&nbsp;
			<Button label="1" @click="show(0)" />&nbsp; <Button label="2" @click="show(1)" />&nbsp;
			<Button label="3" @click="show(2)" />
		</div>

		<div id="slideList" @mouseover="this.pause = true" @mouseleave="
        this.pause = false;
        this.count = 0;
      ">
			<Slide v-for="(slide, index) in slideListModel" :key="index" :slide="slide" :active="activeIndex == index"
				:iterations="this.iterations" title="" />

			<div id="modal" v-if="modal">

				<div class="flexcenter" style="height:100%;justify-content:center;flex-direction: column;">

					<Icon fileName="w3_spinner_light" class="spinner"/>
					<b style="margin-top:20px;color:white;">Hämtar nyheter</b>
				</div>

			</div>

			<div id="controllers">
				<div id="previous" @click="previous" title="Föregående" class="link">
					<img v-if="this.pause" title="Föregående" src="@/assets/button_left.png" />
					<Circle v-if="!this.pause" fileName="w3_chevron_left_white" color="" hover=""
						style="width:20px;height:30px;padding-left:10px;" />
				</div>
				<div id="next" @click="next" title="Nästa" class="link">
					<img v-if="this.pause" src="@/assets/button_right.png" />
					<Circle v-if="!this.pause" fileName="w3_chevron_right_white" color="" hover=""
						style="width:20px;height:30px;padding-right:10px;" />
				</div>
			</div>
		</div>

		<div id="footer">
			&nbsp;
			<div id="dots">
				<div v-for="(slide, index) in slideList" :key="index"
					:class="[{ active: activeIndex == index }, { inactive: activeIndex != index }]" @click="
            activeIndex = index;
            count = 0;
            pause = true;
          " />
			</div>
			<div class="pause">
				<img v-if="pause" src="@/assets/w3_circle_pause_white.png" />
			</div>
		</div>
	</div>
</template>
<script>
import Slide from "@/components/slide/Slide.vue";

export default {
  name: "SlideList",
  components: { Slide },
  props: {
    slideList: Array
  },
  data() {
    return {
      activeIndex: 0,
      pause: false,
      timer: null,
      count: 0,

      //run: false,
      
			iterations: 0
    };
  },
  computed: {
    /*slideListModel() {

      let slideList = this.slideList;

      slideList.map(slide => {
        if (slide && slide.cssJson && this.isValidJson(slide.cssJson)) {
          slide.css = JSON.parse(slide.cssJson);
        } else {
          slide.css = {};
        }

        if (slide && slide.readMoreJson && this.isValidJson(slide.readMoreJson)) {
          slide.readMore = JSON.parse(slide.readMoreJson);
        } else {
          slide.readMore = {};
        }

        if (slide && slide.imageListJson && this.isValidJson(slide.imageListJson)) {
          slide.imageList = JSON.parse(slide.imageListJson);
        } else {
          slide.imageList = {};
        }
      });

      return slideList;
    }*/

		modal(){
			return !this.slideListModel?.length > 0
		},
		slideListModel() {
			return this.slideList.map(slide => {
				const newSlide = { ...slide };

				if (newSlide.cssJson && this.isValidJson(newSlide.cssJson)) {
					newSlide.css = JSON.parse(newSlide.cssJson);
				} else {
					newSlide.css = {};
				}

				if (newSlide.readMoreJson && this.isValidJson(newSlide.readMoreJson)) {
					newSlide.readMore = JSON.parse(newSlide.readMoreJson);
				} else {
					newSlide.readMore = {};
				}

				if (newSlide.imageListJson && this.isValidJson(newSlide.imageListJson)) {
					newSlide.imageList = JSON.parse(newSlide.imageListJson);
				} else {
					newSlide.imageList = {};
				}

				return newSlide;
			});
		}
  },

  methods: {
    onStartPressed() {
      //slide();

      this.ticked(); // FP: 2026 startar animeringen

			
    },
    stop() {
      clearTimeout(this.timer);
      this.timer = "";
    },
    previous() {
      this.activeIndex--;
      if (this.activeIndex <= 0) {
        this.activeIndex = this.slideList.length - 1;
      }
    },
    next() {
      this.activeIndex++;
      if (this.activeIndex >= this.slideList.length) {
        this.activeIndex = 0;
      }
    },
    show(index) {
      this.activeIndex = index;
      this.pause = true;
    },
    ticked() {
      if (!this.pause) {
        this.count++;
        //console.log("FP: tick x: " + this.count);
      }

      if (this.count > 5) {
        this.count = 0;
        this.next();
				this.iterations++;
				
      }

      const context = this;
      clearTimeout(this.timer);
      this.timer = "";

      this.timer = setTimeout(context.ticked, 1 * 1000); // 60 sekunder*/
    },
    isValidJson(string) {
      try {
        JSON.parse(string);
      } catch (e) {
        console.log("FP: Not valid json: ", string);
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.onStartPressed();
  },
  unmounted() {
    clearTimeout(this.timer);
    this.timer = "";
  }
};
</script>

<style scoped>
div#slideView {
  max-width: 1400px;
}
div#slideView div#modal {
  background: black;
  position: relative;
  padding-top: 0px;
  height: 100%;
  pointer-events: none;
  text-align: center;
}



div#slideView div#controllers {
  background: transparent;
  position: relative;

  padding-top: 185px;
  pointer-events: none;
}

div#slideView div#controllers div#previous {
  float: left;
  pointer-events: auto;
}

div#slideView div#controllers div#next {
  float: right;
  pointer-events: auto;
}

div#slideView div#controllers div img {
  height: 30px;
  width: 30px;
  padding-right: 10px;
  padding-left: 10px;
}

div#slideView div#slideList {
  background: black;
  height: 400px;
  overflow: clip;

  /* background-image: url("/images/kolfiber.jpg"); */
  background-image: url("~@/assets/kolfiber.jpg");
}

div#slideView div#footer div#dots {
  background: black;
  display: flex;
  justify-content: center;
  padding: 10px;
  gap: 10px;
}

div#slideView div#footer div#dots div {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 7px;
  cursor: pointer;
}

div#slideView div#footer div#dots div.inactive {
  background: grey;
}

div#slideView div#footer div#dots div.active {
  background: white;
}

div#slideView div#footer {
  display: flex;
  justify-content: space-between;
  background: black;
  color: white;
}

div#slideView div#footer div.pause {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 7px;
  margin-top: 10px;
  margin-right: 5px;
}

div#slideView div#footer div.pause img {
  width: 14px;
  height: 14px;
}
</style>